/* =================================================================================================
 * Page « Harmonie Naturelle » — bandeau des looks révélés au défilement.
 *
 * Le défilement ne fait que déclencher : quand le bandeau arrive vers le
 * milieu de l'écran, il s'ouvre (branches écartées, looks visibles) ; quand
 * il s'en éloigne, dans un sens ou dans l'autre, il se referme.
 *
 * L'ouverture et la fermeture se jouent toujours à la même vitesse (DUREE),
 * quelle que soit la vitesse de défilement (demande d'Océane). Un mouvement
 * en cours peut repartir dans l'autre sens à tout moment, sans saut.
 *
 * Écrit --p (0 = fermé, 1 = ouvert), avec une courbe douce au départ et à
 * l'arrivée. Le calcul ne tourne que pendant un mouvement.
 * ===============================================================================================*/

(function () {
  'use strict';

  if (customElements.get('harmonie-reveal')) return;

  var DUREE = 1900;      // ms pour une ouverture (ou une fermeture) complète
  var OUVRE_SOUS = 0.55; // écart au centre de l'écran sous lequel on ouvre…
  var FERME_AU_DELA = 0.7; // … et au-delà duquel on referme (marge anti-hésitation)

  class HarmonieReveal extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.style.setProperty('--p', 1);
        return;
      }

      this.ouvert = false;   // état visé
      this.avance = 0;       // 0 → 1, progresse à vitesse constante
      this.dernier = 0;
      this.enCours = false;
      this.boucle = this.boucle.bind(this);
      this.verifier = this.verifier.bind(this);

      window.addEventListener('scroll', this.verifier, { passive: true });
      window.addEventListener('resize', this.verifier);
      this.verifier();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.verifier);
      window.removeEventListener('resize', this.verifier);
    }

    /** Position du bandeau → faut-il l'ouvrir ou le fermer ? */
    verifier() {
      var r = this.getBoundingClientRect();
      var h = window.innerHeight;
      // 0 : bandeau centré dans l'écran ; 1 : il touche le bord (haut ou bas).
      var ecart = Math.abs(((r.top + r.height / 2) - h / 2) / (h / 2 + r.height / 2));

      var voulu = this.ouvert;
      if (ecart < OUVRE_SOUS) voulu = true;
      else if (ecart > FERME_AU_DELA) voulu = false;

      if (voulu !== this.ouvert) {
        this.ouvert = voulu;
        this.lancer();
      }
    }

    lancer() {
      if (this.enCours) return;
      this.enCours = true;
      this.dernier = 0;
      window.requestAnimationFrame(this.boucle);
    }

    boucle(temps) {
      var dt = this.dernier ? Math.min(temps - this.dernier, 64) : 16;
      this.dernier = temps;

      var pas = dt / DUREE;
      this.avance = this.ouvert ? Math.min(1, this.avance + pas) : Math.max(0, this.avance - pas);

      // Départ et arrivée en douceur, vitesse régulière au milieu.
      var a = this.avance;
      var p = a < 0.5 ? 2 * a * a : 1 - Math.pow(-2 * a + 2, 2) / 2;
      this.style.setProperty('--p', p.toFixed(4));

      var arrive = this.ouvert ? this.avance === 1 : this.avance === 0;
      if (arrive) { this.enCours = false; return; }
      window.requestAnimationFrame(this.boucle);
    }
  }

  customElements.define('harmonie-reveal', HarmonieReveal);
})();
